// extracted by mini-css-extract-plugin
module.exports = {"updated":"style__updated__oZOe8","links":"style__links__9+ImQ","list":"style__list__PZtP0"};